let _uidCounter = 1;

export function getNextUID(): number {
  return _uidCounter++;
}
